var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFlask = function SvgIconFlask(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.25 4h.5v4.73l-3.697 6.16a1 1 0 0 0-.078.13l-2.148 3.581-.002.002a1.75 1.75 0 0 0 1.488 2.647h15.373a1.75 1.75 0 0 0 1.488-2.647l-1.895-3.158a1 1 0 0 0-.122-.204L15.25 8.73V4h.5a1 1 0 1 0 0-2h-7.5a1 1 0 0 0 0 2m8.751 11.536-3.506-5.843-.011-.02a1.8 1.8 0 0 1-.234-.873V4h-2.5v4.8a1.8 1.8 0 0 1-.234.873l-.012.02-2.418 4.03c1.201-.04 2.646.277 4.36 1.132l.003.001c1.56.782 2.705.973 3.521.918a3.2 3.2 0 0 0 1.031-.238m-10.38.63L4.77 19.25h14.46l-1.194-1.99a5.1 5.1 0 0 1-1.931.51c-1.262.085-2.765-.23-4.552-1.125-2.686-1.34-4.157-.97-4.933-.479",
    clipRule: "evenodd"
  })));
};
export default SvgIconFlask;